import { isMobileLayoutActive } from '@/utils/layoutPreviewMode'

const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  layoutPreviewMode: state => state.app.layoutPreviewMode,
  /** 真机窄屏或超级管理员开启移动端预览 */
  useMobileLayout: state =>
    isMobileLayoutActive(state.app.device, state.app.layoutPreviewMode),
  openEmbedMode: state => state.app.openEmbedMode,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  nickName: state => state.user.nickName,
  companyIds: state => state.user.companyIds,
  roles: state => state.user.roles,
  integrationModuleScope: state => state.user.integrationModuleScope,
  companyFulfillmentSites: state => state.user.companyFulfillmentSites,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js